import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { parseJson, buildApiError } from "./apiHelpers";

const BASE = `${config.BASE_URL}/visitors/permissions/me`;

/** Submodule permissions for the logged-in role (User builder). */
export async function fetchMyRolePermissions(roleSlug) {
  const params = roleSlug ? `?roleSlug=${encodeURIComponent(roleSlug)}` : "";
  const res = await authFetch(`${BASE}${params}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw buildApiError(res, data, "Failed to load permissions");
  }
  return data?.data ?? data;
}
